import React from "react";
import FooterSection1 from "./FooterSection1";
import FooterSection2 from "./FooterSection2";
import FooterSection3 from "./FooterSection3";
import FooterSection4 from "./FooterSection4";

const Footer = () => {
  return (
    <div className="w-[100%]">
      <FooterSection1 />
      <FooterSection2 />
      <FooterSection3 />
      <FooterSection4 />
    </div>
  );
};

export default Footer;
